module.exports = __webpack_public_path__ + "img/native-icon.80dea8f7.svg";